import React from 'react'

const MemberRegister = () => {
  return (
    <div>Member Register</div>
  )
}

export default MemberRegister